export function makeGroup<T>(list: ReadonlyArray<T>, count: number = 2) {
  const m = [];
  do {
    const c: number = m.length * count;
    m.push(list.slice(c, c + count));
  } while (m.length < list.length / count);
  return m;
}
